/**
 * Login Block
 */
(function() {
    $(document).ready(function() {

        const login = $('.js24Login');
        if (!login.length) {
            return;
        }

        window.c24LpFrameJsReady.then(function() {
            const holdingLogin = $('.mod24BlockLoginLink.js24OpenLoginLayer');
            if (!holdingLogin.length) {
                return;
            }

            window._paq.push([
                'trackEvent',
                'PSS_' + window.c24LpKey,
                'AnmeldenLink_showed',
                window.c24LpKey,
            ]);

            $('.mod24BlockLoginLink.js24OpenLoginLayer').on('click', function() {
                window._paq.push([
                    'trackEvent',
                    'PSS_' + window.c24LpKey,
                    'AnmeldenLink_clicked',
                    window.c24LpKey,
                ]);
            });
        });
    });
})();
